module.exports = __webpack_public_path__ + "img/folder-case.d7be016c.svg";